import Crud from '../crud'
let crud = new Crud('/rest/user', {
  idKey: 'username',
  includeIdKeyInRequestBody: true
})

export default {
  namespaced: true,
  state: {
    loading: false,
    data: []
  },
  getters: {
    ...crud.getters
  },
  mutations: {
    ...crud.mutations
  },
  actions: {
    ...crud.actions,
    empty: {
      root: true,
      async handler ({ commit }) {
        commit('setData', [])
      }
    }
  }
}
